import Colors from '../../../../themes/Colors';
import styled from 'styled-components'

const AdLibraryComponentHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 1336px;
  margin: 0 auto;
  padding: 0 24px;

  .ad-library-title {
    font-family: 'Roboto', sans-serif;
    font-size: 48px;
    font-weight: 700;
    margin: 0 0 8px;
    color: ${Colors.textStrong};
  }
`

export default AdLibraryComponentHolder
